import { render, staticRenderFns } from "./DRadioEditor.vue?vue&type=template&id=23f09bcb&"
import script from "./DRadioEditor.vue?vue&type=script&lang=js&"
export * from "./DRadioEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports